import { render } from "./GlobalFeedback.vue?vue&type=template&id=270b977c"
import script from "./GlobalFeedback.vue?vue&type=script&lang=js"
export * from "./GlobalFeedback.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__